import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { Avatar, Toolbar, Typography } from '@mui/material'
import React from 'react'
import classes from './IndividualTeacher.module.css'
import {
  setEmployeeID,
  setLoader,
  setOpenIndividualTeacher,
  setSchoolDInfo,
} from '../../../../../../../redux/globalSlice'
import { DataTable, DateInput, SelectField } from '../../../../../../../components'
import { useGlobal } from '../../../../../../../shared'
import { DashboardHead } from '../../../../Dashboard/DashboardPage'
import { baseURL, urls } from '../../../../../../../shared/config'
import {
  individualfeesHeadCells,
  individualTeacherCells,
} from '../../../../../../../shared/data/headCells'
import { blueArrow, editIco } from '../../../../../../../assets/icons'
import IndividualField from '../../../../../../../common/IndividualField/IndividualField'
import axios from 'axios'
import { uploadImageToS3 } from '../../../../../../../shared/config/S3Utils'
import { toast } from 'react-toastify'
import IndividualFilter from './IndividualFilter/IndividualFilter'
import { formatDate } from '../../../../../../../shared/utils/constants'

const IndividualTeacher = ({ setAddTeacher, form, refetch, setUpdate, update, setDetail }) => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  // const storedAttributes = localStorage.getItem('userAttributes')
  // const attributes = storedAttributes
  // const customRole = attributes?.employee_type
  const dispatch = useDispatch()
  // const [detail, setDetail] = useState(false)
  // const [search, setSearch] = useState('')
  // const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const employeeId = useSelector((state) => state.global.employee_ID)
  const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)

  // console.log('----employeeId', update)

  // const individualStudent = useSelector((state) => state.global.openIndividualStudent)

  // const [schoolName, setSchoolName] = useState('')

  // const api = `${urls.FEES_GET}school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}&page=${pageFee}&limit=${rowsPerPage}`
  // const statusApi = `${urls.FEE_STATUS}${selectedStatus}&page=${pageFee}&limit=${rowsPerPage}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}`
  // const { data: schoolList } = useGlobal({ userUrl: urls.SCHOOL_LIST })
  const [editMode, setEditMode] = useState(!!form)
  const [formValues, setFormValues] = useState({})
  const {
    data: Data,
    // count,
    salaryData,
  } = useGlobal({
    userUrl: `${urls.TEACHER_PROFILE}?employee_id=${employeeId ? employeeId : SchoolDInfo?.employee_id}`,
  })

  const teacher = Data?.[0] || {}

  // console.log('----teacher', teacher)

  const [preview, setPreview] = useState(null)
  // console.log('-------data', Data)
  // const selectedFilter = useSelector((state) => state.global.selectedFilter)
  const [selectedFile, setSelectedFile] = useState(null)
  const row = salaryData
  const currentName = formValues.employee_name || teacher.employee_name || 'Teacher'
  const { data: subjectList, count: subjectCount } = useGlobal({
    userUrl: `${urls.SUBJECT}?page=1&limit=1000&school_id=${userSchoolId}`,
  })
  // const { data: feestatus } = useGlobal({ userUrl: statusApi })

  // const statusFee = feestatus && feestatus?.searchSchoolPayload
  // const { data: searchFee } = useGlobal({
  //   userUrl: `${urls.FEE_SEARCH}${search}&school_id=${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName}`,
  // })
  // const row = search ? searchFee : selectedStatus !== '' ? statusFee : feeData
  // const row = search ? searchFee : Data

  // const pagecount = selectedStatus ? feestatus?.countStudent : count
  //   const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  const genderOptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
  ]

  const handleClose = () => {
    dispatch(setOpenIndividualTeacher(false))
    setAddTeacher(false)
    setPreview(teacher.employee_avatar || null)
    setUpdate(false)
    setDetail(false)
    dispatch(setSchoolDInfo(null))
    dispatch(setEmployeeID(''))
    setEditMode(false)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleToggleEdit = () => {
    setEditMode((prev) => !prev)
  }

  // const [wannaEdit, setWannaEdit] = useState(false)
  const renderField = (label, name, type = 'text', required) => {
    const value = formValues[name] ?? ''

    if (!editMode) {
      return (
        <IndividualField
          label={label}
          name={name}
          type={type}
          value={value}
          onChange={handleInputChange}
          editMode={editMode}
          required={required}
        />
      )
    }

    return (
      <IndividualField
        label={label}
        name={name}
        type={type}
        value={value}
        onChange={handleInputChange}
        editMode={editMode}
      />
    )
  }

  useEffect(() => {
    if (teacher && Object.keys(teacher).length > 0) {
      // Helper to safely convert ISO → YYYY-MM-DD
      const toDateInputFormat = (isoString) => {
        if (!isoString) return ''
        // Take first 10 chars → handles both "2026-04-01T..." and already "2026-04-01"
        return isoString.slice(0, 10)
      }

      setFormValues({
        employee_name: teacher.employee_name || '',
        employee_education: teacher.employee_education || '',
        employee_email: teacher.employee_email || '',
        employee_gender: teacher.employee_gender || '',
        employee_contact_number: teacher.employee_contact_number || '',
        employee_address: teacher.employee_address || '',
        employee_address_two: teacher.employee_address_two || '',
        employee_city: teacher.employee_city || '',
        employee_state: teacher.employee_state || '',
        employee_pincode: teacher.employee_pincode || '',
        employee_salary: teacher.employee_salary || '',
        employee_type: teacher.employee_type || 'Teacher',
        employee_joining_date: toDateInputFormat(teacher.employee_joining_date),
        employee_subject_id: teacher.employee_subject_id || '',
        section_name: teacher.section_name || '',
        grade_name: teacher.grade_name || '',
        employee_password: teacher.employee_password || '',
        // employee_country_code: teacher.employee_country_code || '',
        employee_dob: toDateInputFormat(teacher.employee_dob),
      })

      // Set initial preview from existing avatar
      if (teacher.employee_avatar) {
        setPreview(teacher.employee_avatar)
      }
    }
  }, [teacher])
  const handleSave = async () => {
    if (!validateTeacherForm()) {
      return
    }
    dispatch(setLoader(true))
    try {
      let avatarUrl = teacher.employee_avatar || '' // keep old image if no new one selected

      // ── If user selected a new avatar → upload to S3 ──
      if (selectedFile) {
        const uploadResult = await uploadImageToS3(selectedFile, 'teacher')
        // or however you call it → e.g. await yourS3Function(selectedFile)

        if (!uploadResult) {
          throw new Error('S3 upload failed - no URL returned')
        }

        avatarUrl = uploadResult // ← this is the final S3 public URL
        // avatarUrl = uploadResult.publicUrl || uploadResult.Location || uploadResult.url;
      }

      // ── Prepare payload for backend ──
      const payload = {
        school_id: userSchoolId,
        employee_name: formValues.employee_name || '',
        employee_education: formValues.employee_education || '',
        employee_email: formValues.employee_email || '',
        employee_gender: formValues.employee_gender || '',
        employee_contact_number: formValues.employee_contact_number || '',
        employee_address: formValues.employee_address || '',
        employee_address_two: formValues.employee_address_two || '',
        employee_city: formValues.employee_city || '',
        employee_state: formValues.employee_state || '',
        employee_pincode: formValues.employee_pincode || '',
        employee_salary: Number(formValues.employee_salary) || 0,
        employee_type: formValues.employee_type || 'Teacher',
        employee_joining_date: formValues.employee_joining_date || '',
        employee_subject_id: formValues.employee_subject_id || '',
        employee_avatar: avatarUrl, // ← S3 URL
        ...(update === true ? { employee_id: employeeId } : {}),
        employee_password: formValues.employee_password || '',
        employee_dob: formValues?.employee_dob || '',
        // employee_country_code: formValues?.employee_country_code || '',
      }

      // console.log('---payloadf', payload)

      const response = update
        ? await axios.patch(`${baseURL}${urls.TEACHER_POST}`, payload)
        : await axios.post(`${baseURL}${urls.TEACHER_POST}`, payload)

      if (response?.data?.status === 202 || response?.data?.status === 201) {
        toast.success(`Teacher is ${update ? 'Updated' : 'Added'} Successfully`)
        handleClose()
      } else {
        toast.error('Some Error Has Occured Please try again Later')
      }

      // console.log('✅ Teacher saved successfully with S3 image')

      setEditMode(false)
      setSelectedFile(null)

      // Optional: show success message
      // toast.success("Teacher profile updated successfully");
      // You may want to refetch teacher data here
    } catch (err) {
      console.error('Save failed:', err)
    } finally {
      refetch()
      dispatch(setLoader(false))
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setSelectedFile(file)
      const objectUrl = URL.createObjectURL(file)
      setPreview(objectUrl)

      // Optional: clean up previous object URL
      return () => URL.revokeObjectURL(objectUrl)
    }
  }

  const handleCancel = () => {
    // Reset form values to original data
    if (Data?.[0]) {
      const original = Data[0]
      const toDateInputFormat = (isoString) => {
        if (!isoString) return ''
        return isoString.slice(0, 10) // "2025-06-15T00:00:00.000Z" → "2025-06-15"
      }
      setFormValues({
        employee_name: original.employee_name || '',
        employee_education: original.employee_education || '',
        employee_email: original.employee_email || '',
        employee_gender: original.employee_gender || '',
        employee_contact_number: original.employee_contact_number || '',
        employee_address: original.employee_address || '',
        employee_address_two: original.employee_address_two || '',
        employee_city: original.employee_city || '',
        employee_state: original.employee_state || '',
        employee_pincode: original.employee_pincode || '',
        employee_salary: original.employee_salary || '',
        employee_type: original.employee_type || '',
        // employee_country_code: original.employee_country_code || '',
        employee_joining_date: toDateInputFormat(original.employee_joining_date) || '',
        employee_subject_id: original.employee_subject_id || '',
        section_name: original.section_name || '',
        grade_name: original.grade_name || '',
        employee_dob: toDateInputFormat(original.employee_dob) || '',
      })
    }

    // Reset image preview & file
    setPreview(Data?.[0]?.employee_avatar || null)
    setSelectedFile(null)

    // Exit edit mode
    setEditMode(false)
  }
  const validateTeacherForm = () => {
    const missingFields = []

    // Helper function to safely get string value
    const getStringValue = (value) => {
      if (value === null || value === undefined) return ''
      return String(value).trim()
    }

    // Basic Information
    if (!getStringValue(formValues.employee_name)) missingFields.push('Full Name')
    if (!getStringValue(formValues.employee_gender)) missingFields.push('Gender')
    if (!getStringValue(formValues.employee_dob)) missingFields.push('Date of Birth')
    if (!getStringValue(formValues.employee_education)) missingFields.push('Education')
    // if (!getStringValue(formValues.employee_subject_id)) missingFields.push('Subject')
    if (!getStringValue(formValues.employee_joining_date)) missingFields.push('Joining Date')

    // Contact Information
    if (!getStringValue(formValues.employee_email)) {
      missingFields.push('Email Address')
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.employee_email)) {
      toast.error('Please enter a valid email address')
      return false
    }

    // Password validation for new teachers or when updating password
    if (form || update) {
      if (!getStringValue(formValues.employee_password)) {
        missingFields.push('Password')
      } else if (formValues.employee_password.length < 6) {
        toast.error('Password must be at least 6 characters long')
        return false
      }
    }

    // Phone Number validation
    if (!getStringValue(formValues.employee_contact_number)) {
      missingFields.push('Phone Number')
    } else if (!/^[6-9]\d{9}$/.test(formValues.employee_contact_number)) {
      toast.error('Phone number must be 10 digits starting with 6-9')
      return false
    }

    // Address Information
    if (!getStringValue(formValues.employee_address)) missingFields.push('Address Line 1')
    if (!getStringValue(formValues.employee_city)) missingFields.push('City')
    if (!getStringValue(formValues.employee_state)) missingFields.push('State')

    // Pincode validation
    if (!getStringValue(formValues.employee_pincode)) {
      missingFields.push('Pincode')
    } else if (!/^\d{6}$/.test(formValues.employee_pincode)) {
      toast.error('Pincode must be 6 digits')
      return false
    }

    // Salary validation
    if (!getStringValue(formValues.employee_salary)) {
      missingFields.push('Salary')
    } else {
      const salary = Number(formValues.employee_salary)
      if (isNaN(salary) || salary <= 0) {
        toast.error('Please enter a valid salary amount')
        return false
      }
    }

    // Show missing fields if any
    if (missingFields.length > 0) {
      toast.error(`Please fill required fields: ${missingFields.join(', ')}`)
      return false
    }

    return true
  }

  return (
    <div>
      <Toolbar />
      <div className={classes.parents}>
        <div className="school-toolbar">
          <div
            style={{
              width: '44px',
              height: '44px',
            }}
            className="white-ico"
          >
            <img
              src={blueArrow}
              onClick={handleClose}
              style={{
                width: '24px',
                height: '24px',
                transform: 'rotate(-90deg)',
              }}
              className="svg-to-black"
            />
          </div>
        </div>
        <DashboardHead title={`Teacher Profile`} subtitle={`Employee / Teacher`} />
      </div>
      <div className={classes.top}>
        <div className={classes.lhs}>
          {/* Basic Info */}
          <div className={classes.box}>
            <p className={classes.heading}>Basic Information</p>
            <div className={classes.field}>
              {renderField('Full Name', 'employee_name', 'text', true)}
              {/* {renderField('Gender', 'employee_gender')} */}

              <SelectField
                label={'Gender'}
                required
                options={(genderOptions || [])?.map((prod) => ({
                  value: prod.value,
                  label: prod.label,
                }))}
                row={true}
                width={'auto'}
                name="employee_gender"
                fees={true}
                value={formValues?.employee_gender}
                onChange={(selected) => {
                  // Adjust based on what your SelectField really passes
                  const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
                  setFormValues((prev) => ({
                    ...prev,
                    employee_gender: newValue,
                  }))
                }}
                readOnly={!editMode}
              />
              {/* {renderField('Gender', 'employee_gender')} */}
              <DateInput
                label={'Date of Birth'}
                required
                value={formValues.employee_dob || ''} // ← actual value
                onChange={(e) => {
                  setFormValues((prev) => ({
                    ...prev,
                    employee_dob: e.target.value, // stores YYYY-MM-DD
                  }))
                }}
                row={true}
                disabled={!editMode}
              />
              {renderField('Education', 'employee_education', 'text', true)}
              {/* {renderField('Subject ID', 'employee_subject_id')} */}
              <SelectField
                label={'Subject'}
                required
                options={(subjectList || [])?.map((prod) => ({
                  value: prod.subject_id,
                  label: prod.subject_name,
                }))}
                row={true}
                width={'auto'}
                name="employee_subject_id"
                fees={true}
                value={formValues?.employee_subject_id}
                onChange={(selected) => {
                  // Adjust based on what your SelectField really passes
                  const newValue = selected?.value ?? selected?.target?.value ?? selected ?? ''
                  setFormValues((prev) => ({
                    ...prev,
                    employee_subject_id: newValue,
                  }))
                }}
                readOnly={!editMode}
              />
              {!form && !update && (
                <>
                  {' '}
                  {renderField('Grade', 'grade_name')}
                  {renderField('Section', 'section_name')}
                </>
              )}

              <DateInput
                label={'Joining Date'}
                value={formValues.employee_joining_date || ''} // ← actual value
                onChange={(e) => {
                  setFormValues((prev) => ({
                    ...prev,
                    employee_joining_date: e.target.value, // stores YYYY-MM-DD
                  }))
                }}
                row={true}
                disabled={!editMode}
                required={true}
              />
              {/* {renderField('Employee Type', 'employee_type')} */}
            </div>
          </div>

          {/* Contact */}
          <div className={classes.box}>
            <p className={classes.heading}>Contact Information</p>
            <div className={classes.field}>
              {renderField('Email Address', 'employee_email', 'email', true)}
              {(form || update) &&
                renderField('Password', 'employee_password', 'employee_password', true)}
              {/* {!update && renderField('Country Code', 'employee_country_code', 'text', true)} */}
              {renderField('Phone Number', 'employee_contact_number', 'tel', true)}
            </div>
          </div>

          {/* Address */}
          <div className={classes.box}>
            <p className={classes.heading}>Address</p>
            <div className={classes.field}>
              {renderField('Address Line 1', 'employee_address', 'text', true)}
              {renderField('Address Line 2', 'employee_address_two')}
              {renderField('City', 'employee_city', 'text', true)}
              {renderField('State', 'employee_state', 'text', true)}
              {renderField('Pincode', 'employee_pincode', 'text', true)}
            </div>
          </div>

          {/* Salary & Other */}
          <div className={classes.box}>
            <p className={classes.heading}>Employment Details</p>
            <div className={classes.field}>
              {renderField('Salary (₹)', 'employee_salary', 'number', true)}
            </div>
          </div>
        </div>
        <div className={classes.rhs}>
          <div className={classes.studentField}>
            {editMode ? (
              <>
                <label htmlFor="avatar-upload">
                  {preview ? (
                    <img
                      src={preview}
                      alt="Preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '38.095px',
                        objectFit: 'cover',
                        cursor: 'pointer',
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '38.095px',
                        bgcolor: '#F2ECF9',
                        color: '#492972',
                        fontSize: '2.5rem',
                        cursor: 'pointer',
                      }}
                    >
                      {currentName?.charAt(0)?.toUpperCase() || '?'}
                    </Avatar>
                  )}
                </label>

                <input
                  id="avatar-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />

                <p className={classes.headtxt}>{currentName}</p>

                <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'center',
                  }}
                >
                  {!form && (
                    <button onClick={handleCancel} className={classes.btn}>
                      Cancel
                    </button>
                  )}

                  <button onClick={handleSave} className={classes.btn}>
                    Save
                  </button>
                </div>
              </>
            ) : (
              <>
                {teacher.employee_avatar || preview ? (
                  <img
                    src={preview || teacher.employee_avatar}
                    style={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '38.095px',
                      objectFit: 'cover',
                    }}
                    alt="Teacher avatar"
                    className="employee-img"
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '38.095px',
                      mt: 0,
                      fontSize: '2.5rem',
                      backgroundColor: '#F2ECF9',
                      color: '#492972',
                    }}
                  >
                    {currentName?.charAt(0)?.toUpperCase() || '?'}
                  </Avatar>
                )}

                <p className={classes.headtxt}>{currentName}</p>
                {!form && (
                  <button onClick={handleToggleEdit} className={classes.btn}>
                    <span>
                      <img src={editIco} style={{ width: '20px', height: '20px' }} alt="edit" />
                    </span>
                    Edit Information
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {!form && !update && (
        <>
          <IndividualFilter />
          <DataTable
            rowData={row}
            headCells={individualTeacherCells}
            individualTeacher
            // handleDetailOpen={() => setDetail(true)}
          />
        </>
      )}

      {/* {detail && <FeeInfo open={detail} handleClose={() => setDetail(false)} />} */}
    </div>
  )
}

export default IndividualTeacher
